module.exports = require('../impls/$deep-equal/async-deep-equal.js').__asyncDeepEqual;